import { AutoLogoutConfig } from './types/main';

let autoLogoutConfig: AutoLogoutConfig = {
    dialogCountDownTimeout: undefined,
    userInactiveTimeout: undefined,
};

export const setupAutoLogoutConfig = (data: Partial<AutoLogoutConfig>): void => {
    autoLogoutConfig = {
        ...autoLogoutConfig,
        ...data,
    };
};

export const getAutoLogoutConfig = (): AutoLogoutConfig => autoLogoutConfig;
